import { styled } from '@mui/system'
import { colors, fontSizes } from '../../Components/consts'

export const ScheduleCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  position: 'relative',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    flexDirection: 'column',
  },
}))

export const SliderVert = styled('div')(({ theme }) => ({
  top: 0,
  bottom: 0,
  position: 'sticky',
  borderRight: `solid 0.5px ${colors.lightGrey}`,
  borderLeft: `solid 0.5px ${colors.lightGrey}`,
  borderBottom: `solid 0.5px ${colors.lightGrey}`,
  paddingBottom: 20,
  width: '100%',
  overflowY: 'scroll',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  '& ::-webkit-scrollbar-track': {
    display: 'none',
  },
  flex: 1,
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}))

export const SliderCon = styled('div')(({ theme }) => ({
  border: `solid 0.5px ${colors.lightGrey}`,
  borderBottom: 'none',
  display: 'none',
  [theme.breakpoints.down('md')]: {
    display: 'block',
    margin: theme.spacing(0),
    borderLeft: 'none',
    borderRight: 'none',
  },
}))

export const WeekendCon = styled('div')(({ theme }) => ({
  background: colors.white,
  borderRadius: '0 0 12px 12px',
  padding: theme.spacing(1, 3),
  flex: 4,
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1, 0.5),
  },
}))

export const ScheduleHead = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  background: colors.text,
  borderRadius: '12px 12px 0 0',
  padding: theme.spacing(0, 1),
  marginTop: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    justifyContent: 'center',
    margin: theme.spacing(0, 0.5),
    padding: theme.spacing(0),
  },
  '& .left': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
    },
    '& h1': {
      color: colors.white,
      margin: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        fontSize: fontSizes.semiLarge,
      },
    },
  },
  '& .right': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 10,
    '& p': {
      marginRight: 10,
      [theme.breakpoints.down('sm')]: {
        fontSize: fontSizes.small,
      },
    },
    '& a': {
      color: colors.white,
      textDecoration: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(0.5),
    },
  },
}))

export const HeadItem = styled('a')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  margin: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    marginTop: theme.spacing(0),
  },
  '& .icon': {
    width: 20,
    marginBottom: 7,
  },
  '& a': {
    textDecoration: 'none',
    cursor: 'poiner',
  },
  '& p': {
    color: colors.white,
    margin: theme.spacing(0.25, 2),
    fontSize: '0.8rem',
    fontWeight: 600,
    maxWidth: 100,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.6rem',
      margin: theme.spacing(0.25, 1),
    },
  },
}))

export const Toggle = styled('div')(({ theme }) => ({
  display: 'none',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  margin: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    marginTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
}))

export const Toggle2 = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  margin: theme.spacing(0),
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
  '& p': {
    color: colors.white,
    margin: theme.spacing(0.5, 0),
    fontSize: '0.8rem',
    fontWeight: 600,
    maxWidth: 100,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.6rem',
      margin: theme.spacing(0.25, 1),
    },
  },
}))
export const Footer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  margin: theme.spacing(0, 3, 2),
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
  },
  '& p': {
    color: colors.text,
    margin: theme.spacing(0, 1),
    fontSize: fontSizes.small,
    fontWeight: 600,
  },
  '& a': {
    color: colors.text,
    fontSize: fontSizes.small,
    fontWeight: 'bold',
    textDecoration: 'underline'
  },
}))
